module.exports = __webpack_public_path__ + "static/media/Challenge.ce7c84b1.svg";